import { createGlobalStyle } from "styled-components";
import backgroundImage from "./PhotosGallery/rijinstructeur-best-rijschool-zeeland.jpg"; // Update the path as needed

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    color: darkgoldenrod;
    background: url(${backgroundImage}) no-repeat center center fixed;
    background-size: cover;
    overflow-x: hidden;
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  button, a {
    -webkit-tap-highlight-color: transparent;
  }

  h1, h2, h3 {
    margin: 0.5em 0;
    text-align: center;
  }

  html[lang="ar"] :is(p, h1, h2, h3, li, td, th, span) {
    direction: rtl;
    text-align: right !important;
  }

`;

export default GlobalStyle;
